import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "smartphone"
const SmartphoneIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 18C12.621 18 13.125 18.504 13.125 19.125S12.621 20.25 12 20.25 10.875 19.746 10.875 19.125 11.379 18 12 18M13.5 3.75C13.914 3.75 14.25 4.086 14.25 4.5S13.914 5.25 13.5 5.25H10.5C10.086 5.25 9.75 4.914 9.75 4.5S10.086 3.75 10.5 3.75z" />
          <path
            fillRule="evenodd"
            d="M17.25 1.5C18.078 1.5 18.75 2.172 18.75 3V21C18.75 21.828 18.078 22.5 17.25 22.5H6.75L6.597 22.492C5.84 22.415 5.25 21.777 5.25 21V3C5.25 2.172 5.922 1.5 6.75 1.5zM6.75 21H17.25V17.25H6.75zM6.75 15.75H17.25V3H6.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SmartphoneIcon
